import React from 'react';
import { BoxIcon } from 'lucide-react';
type EmptyStateProps = {
  icon: BoxIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
};
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action
}) => {
  return <div className="flex flex-col items-center justify-center py-12 px-4 text-center bg-white rounded-2xl border border-dashed border-gray-200" data-id="element-374">
      <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center text-gray-400 mb-4" data-id="element-375">
        <Icon size={32} data-id="element-376" />
      </div>
      <h3 className="text-lg font-medium text-brand-text-dark mb-1" data-id="element-377">{title}</h3>
      <p className="text-brand-text-light text-sm max-w-sm mb-6" data-id="element-378">
        {description}
      </p>
      {action}
    </div>;
};